import { CarStatus, type Deviation } from '../../../../../types'
import type { SimpleVehicleProps } from '../types/types'

export function mergeCarsAndDeviations({
  cars,
  deviations = [],
}: {
  cars: SimpleVehicleProps[]
  deviations?: Deviation[]
}) {
  const data = cars.map((car) => {
    const { nextInspectionDate, registrationNumber, budgetNo } = car
    const carId = registrationNumber ? registrationNumber : budgetNo

    const carDeviations = getCarDeviations(carId, deviations)

    const today = new Date()
    const inputDate = new Date(nextInspectionDate)

    const hasLateInspection = inputDate && inputDate.getTime() < today.getTime()
    if (hasLateInspection) {
      carDeviations.push({
        carId,
        code: 'EU-kontroll',
        eventType: 'Inspection',
        date: new Date().toISOString(),
        description: 'EU-kontroll frist passert',
      })
    }

    const warnings: Deviation[] = []

    const odometerDeviation = carDeviations.find((deviation) => deviation.code === 'Km avlesing')
    if (odometerDeviation) {
      if (car.status === CarStatus.Active) warnings.push(odometerDeviation)

      return {
        ...car,
        warnings,
        deviations: carDeviations.filter((d) => d.code !== 'Km avlesing'),
      }
    }

    return {
      ...car,
      warnings,
      deviations: carDeviations,
    }
  })

  return data
}

function getCarDeviations(id: string | null | undefined, deviations: Deviation[]) {
  const carDeviations = deviations?.filter((deviation) => {
    const { carId } = deviation
    return carId === id
  })

  const carDeviationsMap = new Map<string, Deviation>()
  for (const deviation of carDeviations) {
    const { code } = deviation

    const alreadyExists = carDeviationsMap.get(code)
    if (alreadyExists) continue

    carDeviationsMap.set(code, deviation)
  }

  return Array.from(carDeviationsMap.values())
}
